export const enum Section {
    GRAY = 'grey',
    OPPORT = 'opportunity',
    FAQ = 'faq',
    START = 'start',
    PLATFORM = 'platform',
    JOIN = 'join',
    LASR_NEWS = 'last_news',
    PARTHNERS = 'partners',
    FOOTER = 'footer',
    HEADER_TOP = 'header_top',
    HEADER_MAIN = 'header_main',
    HERO = 'hero_general',
    PATIENT = 'hero_patient',
    DOCTOR = 'hero_doctor',
    CLINIC = 'hero_clinic'
}